<ng-container *ngIf="loading$ | async">
    <app-is-loading></app-is-loading>
</ng-container>
<body>    
    <h3 *ngIf="employer">
        <ng-container *ngIf="isEmployerOrStaff()">
            {{employer.organizationName}} : {{employer.organizationID}}
        </ng-container>
        <ng-container *ngIf="!isEmployerOrStaff()">
            System Administrator on behalf of {{employer.organizationName}} : {{employer.organizationID}}
        </ng-container>
    </h3>
    <span class="pageHeader">Special Import Mappings</span>

    <div>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Hours Class" #input>
          </mat-form-field>
        <mat-table [dataSource]="specialMappings" class="mat-elevation-z8" matSort>
            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mainColumns"> Type </mat-header-cell>
              <mat-cell class="mainColumns" *matCellDef="let element"> {{whatType(element)}} </mat-cell>
            </ng-container>
          
            <!-- Name From Employer Column -->
            <ng-container matColumnDef="idFromEmployer">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mainColumns"> Name From Employer </mat-header-cell>
              <mat-cell class="mainColumns" *matCellDef="let element"> {{element.idFromEmployer}} </mat-cell>
            </ng-container>
          
            <!-- Real Value Column -->
            <ng-container matColumnDef="idFinder.parameterCode">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="mainColumns"> Real Value </mat-header-cell>
              <mat-cell class="mainColumns" *matCellDef="let element"> {{element.idFinder.parameterCode}} --> {{element.idFinder.parameterDesc}} </mat-cell>
            </ng-container>
    
            <!-- action Column -->
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef class="deleteColumns"> Delete </mat-header-cell>
                <mat-cell class="deleteColumns" *matCellDef="let element"> 
                    <button mat-icon-button color="warn" title="Delete special mapping used for import processes" (click)="deleteSingleEmployerClassMapping(element)">
                        <mat-icon>delete</mat-icon>
                    </button>    
                </mat-cell>
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [length]="specialMappings.data.length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent = $event" aria-label="Select page">
        </mat-paginator>
    </div>
</body>